import {Elem} from './elem';

const instance = new Elem();

class SkAlert {
  constructor() {
    this.recursionList = [];
  }

  show(html, conf, n) {
    this.recursionList.push([html, conf, n]);
    this.recursion();
  }

  showAlert(html, conf, n) {
    this.isShow = true;
    const sett = conf || {};
    const ok = (o) => {
      this.ok();
      if (sett.ok) {
        sett.ok(o);
      }
    };
    const no = (o) => {
      this.no();
      if (sett.no) {
        sett.no(o);
      }
    };
    const v = {
      ok: sett.okValue,
      no: sett.noValue,
      confirm: n
    };
    instance.merge(html, ok, no, v);
    instance.show();
  }

  recursion() {
    if (this.isShow) {
      return;
    }
    const o = this.recursionList.shift();
    if (o) {
      this.showAlert(o[0], o[1], o[2]);
    }
  }

  hideAlert() {
    instance.hide(() => {
      this.isShow = false;
      if (this.recursionList.length > 0) {
        this.recursion();
      }
    });
  }

  ok() {
    this.hideAlert();
  }

  no() {
    this.hideAlert();
  }
}

const skalert = new SkAlert();

export {skalert};